var HeadingLevels;
(function (HeadingLevels) {
  HeadingLevels["h1"] = "h1";
  HeadingLevels["h2"] = "h2";
  HeadingLevels["h3"] = "h3";
  HeadingLevels["h4"] = "h4";
  HeadingLevels["h5"] = "h5";
  HeadingLevels["h6"] = "h6";
})(HeadingLevels || (HeadingLevels = {}));
export { HeadingLevels };